import { Chip, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAiKnowledgeBaseUsage } from '@/features/company/model/useAiKnowledgeBase';
import { Loader } from '@/shared/ui/Loader';

function formatDateTime(value: string) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
}

export function KnowledgeBaseUsagePanel({
  companyId,
  entryId,
}: {
  companyId: string;
  entryId: string | null;
}) {
  const { t } = useTranslation('company');
  const query = useAiKnowledgeBaseUsage(companyId, entryId ?? '', Boolean(entryId));
  const items = query.data?.items ?? [];

  return (
    <Stack spacing={1} sx={{ minWidth: 0 }}>
      <Typography variant="subtitle2" fontWeight={800}>
        {t('modules.knowledgeBase.usage.title')}
      </Typography>
      {!entryId ? (
        <Typography variant="body2" color="text.secondary">
          {t('modules.knowledgeBase.usage.noSelection')}
        </Typography>
      ) : query.isPending ? (
        <Loader containerSize="small" />
      ) : items.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {t('modules.knowledgeBase.usage.empty')}
        </Typography>
      ) : (
        <Stack spacing={0.75}>
          {items.map((item) => (
            <Stack
              key={item.activity_log_id}
              direction={{ xs: 'column', sm: 'row' }}
              spacing={0.75}
              alignItems={{ xs: 'flex-start', sm: 'center' }}
            >
              <Chip
                size="small"
                label={`${item.source} / ${item.status}`}
                sx={{ borderRadius: 1 }}
              />
              <Typography variant="caption" color="text.secondary">
                {formatDateTime(item.created_at)}
              </Typography>
            </Stack>
          ))}
        </Stack>
      )}
    </Stack>
  );
}
